import React            from 'react';
import Level1           from './level1';
import Level2           from './level2';
import { makeStyles }   from '@material-ui/core/styles';


const useStyles = makeStyles(() => ({
    root: {
        minHeight:       '100vh',
        minWidth:        '100vw',
        maxHeight:       '100vh',
        maxWidth:        '100vw',
        position:        'fixed',
        top:             0,
        left:            0
    }
}))

type NumbersProps = {
    size:           number[];
    wideScreen:     boolean;
    handleNavigate: (val: string) => void;
}


const Numbers: React.FC<NumbersProps> = ({ size, wideScreen, handleNavigate }) => {

  const classes = useStyles();

  const [level, setLevel] = React.useState(1)

  return (
     <div className = { classes.root }>
        {
           level === 1
           &&
           <Level1
              size           = { size }
              wideScreen     = { wideScreen }
              handleNavigate = { handleNavigate }
              setLevel       = { setLevel }
           />
        }
        {
           level === 2
           &&
           <Level2
              size           = { size }
              wideScreen     = { wideScreen }
              handleNavigate = { handleNavigate }
              setLevel       = { setLevel }
           />
        }
     </div>
  );
}



export default Numbers;
